import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { getInvoice, getInvoicebyid } from "../../Actions/actions";
import { useSelector } from "react-redux";
import moment from "moment";

const InvoiceHistorySubscription = () => {
  const { invoice, loader, loginData } = useSelector(
    (state) => state.userReducer
  );
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getInvoicebyid(loginData?.accessToken, loginData?.clientData?.id));
  }, []);
  // const invoices = [
  //     { id: "INV-1990", date: '19 Jan 2022', amount: "AED 91.69" },
  //     { id: "INV-1991", date: '19 Jan 2024', amount: "AED 90.69" },
  //     { id: "INV-1992", date: '19 Jan 2025', amount: "AED 90.69" },
  //     { id: "INV-1993", date: '19 Jan 2022', amount: "AED 90.69" },
  //     { id: "INV-1994", date: '19 Jan 2021', amount: "AED 90.69" },
  // ];

  console.log(loginData);
  return (
    <div className="w-full md:w-1/3 space-y-8 md:mt-0 sm:mt-4">
      <div className="bg-white p-4 rounded-2xl shadow-lg space-y-4">
        <h2 className="text-xl font-semibold">Invoice History</h2>
        <div className="space-y-4">
          {invoice.map((invoice, idx) => (
            <div key={idx} className="flex justify-between">
              <div className="min-w-[120px]">
                <p className="text-sm">{invoice?.invoiceNumber}</p>
                <p className="text-gray-400 text-xs">
                  {moment(invoice?.invoiceDate).format("DD-MMM-yy")}
                </p>
              </div>
              <div className="flex flex-col items-end">
                <span className="text-gray-600 text-sm self-center min-w-[70px] text-right">
                  AED {invoice?.amount / 100}
                </span>
                <button className="text-[#361D32] text-sm underline hover:text-[blue]">
                  PDF
                </button>
              </div>
            </div>
          ))}
        </div>
        {/* <button className="text-sm text-black hover:underline mt-2">Show More</button> */}
      </div>
    </div>
  );
};

export default InvoiceHistorySubscription;
